import * as React from "react"

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    attributes: Record<string, string>
    label: string
}

export const Button = ({ attributes, label, ...attrs }: Props): JSX.Element => {
    return (
        <button className="is-link" {...attrs} {...attributes}>
            {label}
        </button>
    )
}

export default Button
